import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import SplashScreen from '@/components/SplashScreen'
import StartScreen from '@/components/StartScreen'
import InsertWells from '@/components/InsertWells'
import InsertWells96 from '@/components/InsertWells96'
import StartTest from '@/components/StartTest'
import Results from '@/components/Results'
import Exportdone from '@/components/ExportDone'
import Init from '@/components/Init'
import AdminExport from '@/components/AdminExport'
import TechMenu from '@/components/Techmenu'
import Rerender from '@/components/Rerender'
import Status from '@/components/Status'
import Proto from '@/components/Proto'
import Pairing from '@/components/Pairing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        name: 'SplashScreen',
        component: SplashScreen,
        props: true,
      },
      {
        path: '/init',
        name: 'Init',
        component: Init,
        props: true,
      },      
      {
        path: '/start',
        name: 'StartScreen',
        component: StartScreen,
        props: true,
      },
      {
        path: '/wells',
        name: 'InsertWells',
        component: InsertWells,
        props: true,
      },
      {
        path: '/wells96',
        name: 'InsertWells96',
        component: InsertWells96,
        props: true,
      },      
      {
        path: '/testing',
        name: 'StartTest',
        component: StartTest,
        props: true,
      },
      {
        path: '/results',
        name: 'results',
        component: Results,
        props: true,
      },
      {
        path: '/export',
        name: 'export',
        component: Exportdone,
        props: true,
      },
      {
        path: '/admin',
        name: 'admin',
        component: AdminExport,
        props: true,
      },
      {
        path: '/techmenu',
        name: 'support',
        component: TechMenu,
        props: true,
      },
      {
        path: '/rerender/:id',
        name: 'rerender',
        component: Rerender,
        props: true,
      },
      {
        path: '/status',
        name: 'status',
        component: Status,
        props: true,
      },
      {
        path: '/proto',
        name: 'proto',
        component: Proto,
        props: true,
      },
      {
        path: '/pairing',
        name: 'pairing',
        component: Pairing,
        props: true,
      },


  ]
})